<template>
	<v-layout row v-if="!titlesSame">
		<v-flex xs6>
			<old-version-marker/>
			<offer-english-name
				v-model="old"
				:readonly="true"
			></offer-english-name>
		</v-flex>
		<v-flex xs6>
			<new-version-marker/>
			<offer-english-name
				v-model="current"
				:readonly="true"
			></offer-english-name>
		</v-flex>
	</v-layout>
</template>
<script>
	import NewVersionMarker from "./NewVersionMarker";
	import OldVersionMarker from "./oldVersionMarker";
	import OfferEnglishName from "../components/OfferEnglishName";

	export default {
		name: 'compareEnglishTitles',
		components: {OfferEnglishName, NewVersionMarker, OldVersionMarker},

		computed: {
			titlesSame () {
				let comparisonResult = this.current === this.old;
				if (comparisonResult === false) {
					this.$emit('dataDiffer', true);
				}
				return comparisonResult;
			}
		},

		props: {
			current: {},
			old: {},
		}
	};
</script>
